'use client'

import Link from 'next/link'
import '@/app/public.css'

const sections = [
  {
    title: 'What we collect',
    body:
      'We collect the information needed to create and secure your account, comply with regulatory obligations, and operate product features. This can include contact details, device identifiers, onboarding data, and transaction-related records.',
  },
  {
    title: 'Why we use it',
    body:
      'Your data is used to provide the service, prevent fraud, enforce access policy, validate invitations and referrals, support customers, and comply with legal and financial obligations.',
  },
  {
    title: 'How we protect it',
    body:
      'We apply access controls, audit trails, and operational safeguards to reduce misuse or unauthorized disclosure. Some retention periods are required by compliance, fraud prevention, and security monitoring rules.',
  },
  {
    title: 'Your choices',
    body:
      'You can contact support regarding account access, data correction, or privacy questions. Some requests may be limited when data must be retained for compliance, security, or dispute resolution.',
  },
]

export default function PrivacyPage() {
  return (
    <main style={{ minHeight: '100vh', paddingTop: '80px', paddingBottom: '40px' }}>
      <div className="container" style={{ maxWidth: '800px' }}>
        <div style={{ marginBottom: '40px', display: 'flex', alignItems: 'start', justifyContent: 'space-between', gap: '24px', flexWrap: 'wrap' }}>
          <div>
            <p style={{ fontSize: '10px', fontWeight: '500', letterSpacing: '0.15em', textTransform: 'uppercase', color: 'var(--text-muted)', marginBottom: '12px' }}>
              BPAL Legal
            </p>
            <h1 style={{ fontSize: 'clamp(32px, 5vw, 48px)', fontWeight: '700', letterSpacing: '-0.02em', color: 'var(--text)', marginTop: '12px' }}>
              Privacy Policy
            </h1>
          </div>
          <Link href="/register" className="btn-secondary" style={{ marginTop: '12px' }}>
            Back to registration
          </Link>
        </div>

        <div style={{ display: 'flex', flexDirection: 'column', gap: '24px' }}>
          {sections.map((section) => (
            <section key={section.title} className="definition-block">
              <h2 style={{ fontSize: '18px', fontWeight: '600', color: 'var(--text)', marginBottom: '12px' }}>{section.title}</h2>
              <p style={{ fontSize: '15px', color: 'var(--text-muted)', lineHeight: '1.7' }}>{section.body}</p>
            </section>
          ))}
        </div>
      </div>
    </main>
  )
}
